<template>
  <div>
    <div class="row sticky-button">
      <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 px-0">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.number_of_ranges')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.totalDetail"
          />
        </div>
      </div>
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 px-0">
        <label>{{ `${$t('common_words.max_allowed_ranges')}: 5` }}</label>
      </div>
    </div>
    <div v-for="n in model.totalDetail" :key="n">
      <card>
        <label>
          <strong>{{ $t('common_words.record_number') }}: {{ n }}</strong>
        </label>
        <div class="row">
          <div class="col-2">
            <div class="form-group has-label">
              <label>{{ $t('common_words.range') }}: *</label>
              <br />
              <el-select
                clearable
                filterable
                :class="`select-primary custom-width-select shadow-sm required-range_value_${
                  n - 1
                }`"
                size="large"
                v-model="model.range[n - 1]"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="item in getRangeNumbers"
                  :key="item.id + '-' + item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-10 col-lg-4 col-xl-4">
            <div class="form-group has-label">
              <label>{{ $t('common_words.name') }}: *</label>
              <br />
              <el-select
                clearable
                filterable
                :class="`select-primary custom-width-select shadow-sm required-range_name_${
                  n - 1
                }`"
                size="large"
                v-model="model.name_range[n - 1]"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="item in getRangeNames"
                  :key="item.id + item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div :class="`col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('common_words.color') }}</label>
              <div class="block">
                <el-color-picker
                  :class="`select-primary custom-width-select shadow-sm`"
                  v-model="model.background_color[n - 1]"
                  :show-alpha="false"
                  color-format="hex"
                ></el-color-picker>
              </div>
            </div>
          </div>
          <div :class="`col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('common_words.text_color') }}</label>
              <div class="block">
                <el-color-picker
                  :class="`select-primary custom-width-select shadow-sm`"
                  v-model="model.text_color[n - 1]"
                  :show-alpha="false"
                  color-format="hex"
                ></el-color-picker>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <fg-input
              type="number"
              step="0.001"
              min="0"
              :label="`${$t('common_words.from2')}: * `"
              v-model="model.from[n - 1]"
              :name="`common_words.from2_${n - 1}`"
              v-validate="modelValidations.from"
              :error="getFieldErrorByIndex('common_words.from2', true, n - 1)"
              placeholder="..."
            >
            </fg-input>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('common_words.operator_from') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              :class="`select-primary custom-width-select shadow-sm required-from_operator_${
                n - 1
              }`"
              size="large"
              v-model="model.from_operator[n - 1]"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in getOperators"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <fg-input
              type="number"
              step="0.001"
              min="0"
              :label="`${$t('common_words.to')}: * `"
              v-model="model.to[n - 1]"
              :name="`common_words.to_${n - 1}`"
              v-validate="modelValidations.to"
              :error="getFieldErrorByIndex('common_words.to', true, n - 1)"
              placeholder="..."
            >
            </fg-input>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('common_words.operator_to') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              :class="`select-primary custom-width-select shadow-sm required-to_operator_${
                n - 1
              }`"
              size="large"
              v-model="model.to_operator[n - 1]"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in getOperators"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      rangeNumbers: [],
      rangeNames: [],
      operators: [],
      model: {
        totalDetail: 1,
        ids: [],
        range: [],
        name_range: [],
        text_color: [],
        background_color: [],
        from: [],
        from_operator: [],
        to: [],
        to_operator: [],
        range_details: [],
      },
      modelValidations: {
        from: { required: true, min_value: 0 },
        to: { required: true, min_value: 0 },
      },
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  computed: {
    getRangeNames() {
      return [
        { id: 1, value: 'Muy Malo', laber: i18n.t('common_words.very_bad') },
        { id: 2, value: 'Malo', laber: i18n.t('common_words.bad') },
        { id: 3, value: 'Regular', laber: i18n.t('common_words.regular') },
        { id: 4, value: 'Bueno', laber: i18n.t('common_words.good') },
        { id: 5, value: 'Muy Bueno', laber: i18n.t('common_words.very_good') },
      ];
    },
    getRangeNumbers() {
      return [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 4 },
        { id: 5, value: 5 },
      ];
    },
    getOperators() {
      return [
        { id: 1, value: '<' },
        { id: 2, value: '>' },
        { id: 3, value: '<=' },
        { id: 4, value: '>=' },
      ];
    },
  },
  methods: {
    handlePlus() {
      if (this.model.totalDetail != 5) this.model.totalDetail++;
    },
    handleMinus() {
      const minNumber = 1;
      if (this.model.totalDetail > minNumber) {
        // this.handleNumberChange();
        this.model.totalDetail--;
      }
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        for (let index = 0; index < this.model.totalDetail; index++) {
          if (!isset(this.model.range[index])) {
            return this.validationInputsRequired(`range_value_${index}`);
          } else if (!isset(this.model.name_range[index])) {
            return this.validationInputsRequired(`range_name_${index}`);
          } else if (!isset(this.model.background_color[index])) {
            SweetAlert.warning(i18n.t('sweet_alert.common.check_colors'));

            return false;
          } else if (!isset(this.model.text_color[index])) {
            SweetAlert.warning(i18n.t('sweet_alert.common.check_text_colors'));

            return false;
          } else if (!isset(this.model.from[index])) {
            return this.validationInputsRequired(`from_${index}`);
          } else if (!isset(this.model.from_operator[index])) {
            return this.validationInputsRequired(`from_operator_${index}`);
          } else if (!isset(this.model.to[index])) {
            return this.validationInputsRequired(`to_${index}`);
          } else if (!isset(this.model.to_operator[index])) {
            return this.validationInputsRequired(`to_operator_${index}`);
          }
          const detail = {
            range: this.model.range[index],
            name: this.model.name_range[index],
            text_color: this.model.text_color[index],
            background_color: this.model.background_color[index],
            from: this.model.from[index],
            from_operator: this.model.from_operator[index],
            to: this.model.to[index],
            to_operator: this.model.to_operator[index],
          };
          this.model.range_details.push(detail);
        }
        this.$emit('on-validated', this.model);

        return isValid;
      });
    },
  },
  mounted() {
    const editForm = sessionStorage.getItem('editForm');
    if (this.isUpdate() && editForm) {
      console.log('editForm', JSON.parse(editForm));
      const { range_color_details } = JSON.parse(editForm);
      this.model.totalDetail = range_color_details.length;
      for (let index = 0; index < this.model.totalDetail; index++) {
        this.model.ids[index] = range_color_details[index].id;
        this.model.range[index] = range_color_details[index].range;
        this.model.name_range[index] = range_color_details[index].name;
        this.model.text_color[index] = range_color_details[index].text_color;
        this.model.background_color[index] =
          range_color_details[index].background_color;
        this.model.from[index] = range_color_details[index].from;
        this.model.from_operator[index] =
          range_color_details[index].from_operator;
        this.model.to[index] = range_color_details[index].to;
        this.model.to_operator[index] = range_color_details[index].to_operator;
        this.model.range_details[index] =
          range_color_details[index].range_details;
      }
    }
  },
};
</script>
